import { jsx as C } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M22.9419 8.8969C22.8 8.4811 22.4248 8.1874 21.987 8.1533L15.7157 7.655L13.0019 1.6479C12.8248 1.253 12.4321 1 11.9998 1C11.5675 1 11.1748 1.253 10.9977 1.6468L8.28388 7.655L2.01257 8.1533C1.58246 8.1874 1.21175 8.4701 1.06544 8.876C0.919137 9.2819 1.02254 9.7362 1.33165 10.0376L5.9661 14.5553L4.32705 21.6525C4.22584 22.0914 4.40295 22.5479 4.77366 22.8042C4.96287 22.934 5.18068 23 5.39958 23C5.61189 23 5.8253 22.9384 6.0101 22.8152L11.9998 18.8222L17.9895 22.8152C18.3723 23.0704 18.875 23.0605 19.249 22.7888C19.6208 22.5171 19.7848 22.0408 19.6582 21.5986L17.6463 14.5586L22.636 10.0684C22.9628 9.7736 23.0827 9.3138 22.9419 8.8969Z",
    fill: "currentColor"
  }
);
export {
  r as default
};
